
import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    LinearProgress,
    Alert,
    Box
} from '@mui/material';

import {
    modalModifShow,
    modif,
    update
} from './objectifSlice';


const apiUrl = process.env.REACT_APP_API_URL;

export default function Modifier() {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const objectifData = useSelector(
        state => state.objectifsData
    );

    const { id, apitoken } = useSelector(
        state => state.userData
    );

    const currentelement = objectifData.current;

    const [valObjectif, setValObjectif] = useState('');

    const [chargement, setChargement] = useState(false);
    const [erreur, setErreur] = useState('');

    // -------------------------------------------------------
    // Initialisation lors de l'ouverture
    // -------------------------------------------------------

    useEffect(() => {

        if (
            objectifData.modalModifShow &&
            currentelement?._id
        ) {
            setValObjectif(
                String(currentelement.objectif_ca ?? '')
            );

            setErreur('');
        }

    }, [
        objectifData.modalModifShow,
        currentelement
    ]);

    // -------------------------------------------------------
    // Fermer
    // -------------------------------------------------------

    const fermer = () => {

        if (chargement) {
            return;
        }

        dispatch(modalModifShow(false));

        setValObjectif('');
        setErreur('');
    };

    // -------------------------------------------------------
    // Enregistrer la modification
    // -------------------------------------------------------

    const enregistrer = async () => {

        if (chargement) {
            return;
        }

        setErreur('');

        if (!currentelement?._id) {
            setErreur('Aucun objectif sélectionné.');
            return;
        }

        const montant = Number(valObjectif);

        if (
            valObjectif === '' ||
            !Number.isFinite(montant) ||
            montant <= 0
        ) {
            setErreur(
                'Veuillez saisir un objectif CA supérieur à zéro.'
            );
            return;
        }

        // ---------------------------------------------------
        // Notre ObjectifModel attend les 3 propriétés.
        //
        // Le backend ne modifiera que objectif_ca.
        // ---------------------------------------------------

        const data = {
            prevendeur: {
                id: currentelement.prevendeur.id,
                nom: currentelement.prevendeur.nom
            },

            marque: {
                id: currentelement.marque.id,
                designation:
                    currentelement.marque.designation
            },

            objectif_ca: montant
        };

        try {

            setChargement(true);

            const response = await axios.post(
                `${apiUrl}edit/objectif/${id}/${apitoken}/${currentelement._id}`,
                data
            );

            if (response.data.status === 'ok') {

                const objectifModifie = {
                    ...currentelement,
                    objectif_ca: montant
                };

                // Mise à jour de la liste Redux
                dispatch(update(objectifModifie));

                // Notification de succès
                dispatch(modif(true));

                // Fermeture du dialog
                dispatch(modalModifShow(false));

                setValObjectif('');
                setErreur('');

            } else {

                setErreur(
                    "Impossible de modifier cet objectif."
                );
            }

        } catch (error) {

            console.error(error);

            if (error.response?.status === 401) {

                navigate('/');

            } else if (error.response?.status === 404) {

                setErreur(
                    "Cet objectif n'existe plus pour le mois courant."
                );

            } else if (error.response?.status === 422) {

                setErreur(
                    'Les données envoyées sont invalides.'
                );

            } else {

                setErreur(
                    'Une erreur est survenue pendant la modification.'
                );
            }

        } finally {

            setChargement(false);
        }
    };

    // -------------------------------------------------------
    // Interface
    // -------------------------------------------------------

    return (
        <Dialog
            open={objectifData.modalModifShow}
            onClose={fermer}
            fullWidth
            maxWidth="sm"
        >

            <DialogTitle>
                Modifier un objectif commercial
            </DialogTitle>

            {chargement && <LinearProgress />}

            <DialogContent>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3,
                        pt: 2
                    }}
                >

                    {/* Prévendeur : non modifiable */}

                    <TextField
                        fullWidth
                        label="Prévendeur"
                        value={
                            currentelement?.prevendeur?.nom || ''
                        }
                        disabled
                    />

                    {/* Marque : non modifiable */}

                    <TextField
                        fullWidth
                        label="Marque"
                        value={
                            currentelement?.marque?.designation || ''
                        }
                        disabled
                    />

                    {/* Objectif CA : modifiable */}

                    <TextField
                        fullWidth
                        label="Objectif chiffre d'affaires (DH)"
                        type="number"
                        value={valObjectif}
                        onChange={(event) => {
                            setValObjectif(event.target.value);
                            setErreur('');
                        }}
                        disabled={chargement}
                        inputProps={{
                            min: 0.01,
                            step: 0.01
                        }}
                    />

                    {/* Message d'erreur */}

                    {erreur && (
                        <Alert severity="error">
                            {erreur}
                        </Alert>
                    )}

                </Box>

            </DialogContent>

            <DialogActions sx={{ p: 2 }}>

                <Button
                    onClick={fermer}
                    disabled={chargement}
                >
                    Annuler
                </Button>

                <Button
                    variant="contained"
                    onClick={enregistrer}
                    disabled={chargement}
                >
                    Enregistrer
                </Button>

            </DialogActions>

        </Dialog>
    );
}
